export enum GENERAL_TYPES {
  OPEN_MODAL_ERROR = 'OPEN_MODAL_ERROR',
  CLOSE_MODAL_ERROR = 'CLOSE_MODAL_ERROR',
  OPEN_MODAL_INFO = 'OPEN_MODAL_INFO',
  CLOSE_MODAL_INFO = 'CLOSE_MODAL_INFO',
  OPEN_MODAL_MESSAGE = 'OPEN_MODAL_MESSAGE',
  CLOSE_MODAL_MESSAGE = 'CLOSE_MODAL_MESSAGE',
  SHOW_LOADER = 'SHOW_LOADER',
  OPEN_MODAL_SUSCRIPCION = 'OPEN_MODAL_SUSCRIPCION',
  CLOSE_MODAL_SUSCRIPCION = 'CLOSE_MODAL_SUSCRIPCION',
  OPEN_TOAST = 'OPEN_TOAST',
  CLOSE_TOAST = 'CLOSE_TOAST',
  OPEN_MODAL_LIMITE = 'OPEN_MODAL_LIMITE',
  CLOSE_MODAL_LIMITE = 'CLOSE_MODAL_LIMITE',
  GENERAL_ACTIVE_MODA_EDIT = 'GENERAL_ACTIVE_MODA_EDIT', 
  GENERAL_SET_HORA = 'GENERAL_SET_HORA', 
  GENERAL_SET_RETURN_VALID = 'GENERAL_SET_RETURN_VALID',
}
